// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0919965f","239":"bb212b4b","453":"a342fb9a","622":"b5832ff0"}[chunkId] + ".chunk.js";
};